module.exports = __webpack_public_path__ + "img/trello.5f9bc824.svg";